import { HttpClient } from "../../../../shared/infrastructure";
import { NeedHelpResponse } from "../../domain/entities/need-help-entity";

import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from "@tanstack/react-query";

const NEED_HELP_ENDPOINT = "helps";

const needHelpKeys = {
  all: ["need-help"] as const,
};

const useNeedHelp = (
  config?: UseQueryOptions<NeedHelpResponse>
): UseQueryResult<NeedHelpResponse> => {
  return useQuery<NeedHelpResponse>(
    needHelpKeys.all,
    async () =>
      (
        await HttpClient.get<NeedHelpResponse>(
          `${NEED_HELP_ENDPOINT}?help_id=login`
        )
      ).data,
    config
  );
};

export { useNeedHelp };
